/**
 * Dispara um link de aplicativo externo (`rustdesk://`, `anydesk://`) sem mexer
 * na página.
 *
 * As duas formas óbvias falham aqui, cada uma do seu jeito. Navegar a janela
 * (`location.href = uri`) tira o painel da tela: ele roda dentro de um iframe, e
 * quem navega é o iframe. Abrir em aba nova resolve o painel, mas a aba aparece,
 * dispara o app e se fecha — um piscar que o atendente lê como "não funcionou",
 * e que não distingue o app tendo aberto de nada ter acontecido.
 *
 * Um iframe descartável é o caminho que não perturba nada: o navegador entrega o
 * link ao sistema operacional e a página segue intacta. Vale pelo gesto do
 * usuário — precisa ser chamado de dentro de um clique, senão o navegador
 * recusa lançar aplicativo externo.
 */
export function openExternalApp(uri: string): void {
  const frame = document.createElement('iframe');

  frame.style.display = 'none';
  frame.setAttribute('aria-hidden', 'true');
  // `sandbox` sem `allow-*` proibiria a navegação que é justamente o objetivo;
  // o `src` é montado por nós a partir de um ID numérico validado no servidor.
  frame.src = uri;

  document.body.appendChild(frame);

  // Dois segundos é folga suficiente para o navegador processar o lançamento;
  // deixar o iframe na página acumularia um por clique.
  window.setTimeout(() => frame.remove(), 2000);
}
